import React from 'react';

import cn from 'classnames';
import { useTranslation } from 'react-i18next';

import { Flex, UITooltip } from '@shared/ui';
import { TOrderItem } from '@widgets/OrdersRecognition/model/types';

import cls from './OrderAvatar.module.css';

interface IOrderAvatarProps {
    userData?: TOrderItem['createdBy'];
    className?: string;
}
export const OrderAvatar = ({ userData, className }: IOrderAvatarProps) => {
    const { t } = useTranslation();

    return (
        <Flex className={cn(cls.OrderAvatar, className)}>
            {userData && (
                <UITooltip
                    closeDelay={50}
                    label={
                        <span>
                            {userData?.isRemovedFromCompany && (
                                <>
                                    <strong>
                                        {t('OrderRecognition.User.IsRemovedFromCompany.text')}
                                    </strong>{' '}
                                    <br />
                                </>
                            )}
                            {userData?.name} <br />
                            {userData?.email}
                        </span>
                    }
                >
                    {userData?.avatar?.length > 0 && (
                        <img src={userData?.avatar} alt="order avatar" />
                    )}
                </UITooltip>
            )}
        </Flex>
    );
};
